import axios from "axios";
import { redirect } from "react-router-dom";
import { serverUrl } from "../Data/Data";

export const bugzillaApiLoader = async (endpoint) => {
  const bugzillaToken = localStorage.getItem("bugzillaToken");

  if (!bugzillaToken) {
    throw redirect("/admin/buzilla/login");
  }

  const configHeadersBugzilla = {
    headers: {
      Authorization: `Bearer ${bugzillaToken}`,
    },
  };

  try {
    const res = await axios.get(
      `${serverUrl}${endpoint}`,
      configHeadersBugzilla,
    );

    return res.data.data;
  } catch (error) {
    const status = error.response?.status;

    if (status === 401 || status === 403) {
      localStorage.removeItem("bugzillaToken");
      throw redirect("/admin/buzilla/login");
    }

    throw new Response(error.response?.data?.message || "Failed to load data", {
      status: status || 500,
    });
  }
};

export const bugzillaApiLoaderForLayout = async () => {
  const bugzillaToken = localStorage.getItem("bugzillaToken");
  const userId = localStorage.getItem("bugzillaUserId");

  if (!bugzillaToken || !userId) {
    return redirect("/admin/bugzilla/login");
  }

  const configHeadersBugzilla = {
    headers: {
      Authorization: `Bearer ${bugzillaToken}`,
    },
  };

  try {
    const res = await axios.post(
      `${serverUrl}/bugzilla/auth/get-user`,
      { id: userId },
      configHeadersBugzilla,
    );

    return res.data.data;
  } catch (error) {
    const status = error.response?.status;

    if (status === 401 || status === 403) {
      localStorage.removeItem("bugzillaToken");
      return redirect("/");
    }

    throw new Response(error.response?.data?.message || "Failed to load data", {
      status: status || 500,
    });
  }
};

export const apiLoader = async (endpoint) => {
  const token = localStorage.getItem("token");

  if (!token) {
    return redirect("/");
  }

  try {
    const res = await axios.get(`${serverUrl}${endpoint}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return res.data.data;
  } catch (error) {
    const status = error.response?.status;

    // 🔐 AUTH FAILURE → LOGOUT + REDIRECT
    if (status === 401 || status === 403) {
      localStorage.removeItem("token");
      return redirect("/");
    }

    // ❌ OTHER ERRORS → ERROR BOUNDARY
    throw new Response(error.response?.data?.message || "Failed to load data", {
      status: status || 500,
    });
  }
};

export const bugzillaLoginLoader = async () => {
  const bugzillaToken = localStorage.getItem("bugzillaToken");
  const token = localStorage.getItem("token");
  const userId = localStorage.getItem("bugzillaUserId");

  if (bugzillaToken && token && userId) {
    // ⛔ block login page immediately
    return redirect(`/admin/bugzilla/user/${userId}/dashboard`);
  }

  return null; // allow login page
};
